import { Helmet } from 'react-helmet-async';

export const Cooperation = () => {
    return (
        <>
            <Helmet>
                <title>Księgowość w Czechach | Współpraca | Biuro rachunkowe Saldo.pl</title>
                <meta name="description" content="Współpracujemy z czeskim biurem rachunkowym ECOAR spol. s r.o. Kompleksowa obsługa księgowa dla polskich firm działających w Czechach. Kontakt w języku polskim." />
                <meta name="keywords" content="księgowość w Czechach, firma w Czechach, polskie firmy w Czechach, doradca podatkowy Czechy, ECOAR, współpraca księgowa" />
                <link rel="canonical" href="https://podatki-saldo.pl/cooperation" />
                <meta property="og:title" content="Współpraca | Współpraca międzynarodowa" />
                <meta property="og:description" content="Kompleksowa obsługa księgowa dla polskich firm działających w Czechach. Pełne wsparcie i kontakt w języku polskim." />
                <meta property="og:url" content="https://podatki-saldo.pl/cooperation" />
                <meta property="og:type" content="website" />
            </Helmet>
            <div className="main-content">
                <div className={"cooperation-main"}>
                    <div style={{maxWidth: '800px', margin: '0 auto', padding: '40px 20px', fontFamily: 'Arial, sans-serif', color: "#000"}}>
                        <h1 style={{color: '#7CB342', textAlign: 'center', fontSize: '48px', marginBottom: '40px', fontWeight: 'normal'}}>
                            Księgowość w Czechach
                        </h1>

                        <p style={{textAlign: 'center', fontSize: '18px', lineHeight: '1.6', marginBottom: '40px'}}>
                            Dla wszystkich zainteresowanych, chcących otworzyć firmę w Republice Czeskiej, poniżej zamieszczamy dane kontaktowe do Doradcy Podatkowego w Czechach, z którym nasze biuro współpracuje od 2005 roku. Firma godna polecenia, obsługują podmioty polskie prowadzące działalność na terenie Republiki Czeskiej.
                        </p>

                        <p style={{textAlign: 'center', fontSize: '20px', fontWeight: 'bold', marginBottom: '50px'}}>
                            Zapewniają kontakt w języku polskim.
                        </p>

                        <div style={{textAlign: 'center'}}>
                            <h2 style={{fontSize: '24px', marginBottom: '10px'}}>ECOAR spol. s r.o.</h2>
                            <p style={{fontSize: '18px', margin: '5px 0'}}>IČ: 60778628</p>
                            <p style={{fontSize: '18px', margin: '5px 0'}}>E. Krásnohorské 1298 / 4</p>
                            <p style={{fontSize: '18px', margin: '5px 0'}}>Havířov - Podlesí</p>
                            <p style={{fontSize: '18px', margin: '5px 0', marginBottom: '30px'}}>736 01</p>

                            <p style={{fontSize: '18px', margin: '20px 0'}}>Krajský soud v Ostravě, oddíl C, vložka 6678</p>

                            <p style={{fontSize: '18px', margin: '20px 0'}}>Ing. Anna Gališinová</p>

                            <p style={{fontSize: '18px', margin: '20px 0'}}>Jednatelka & majitelka společnosti</p>

                            <div style={{marginTop: '30px'}}>
                                <p style={{fontSize: '18px', margin: '10px 0'}}>
                                    <span style={{color: '#7CB342', fontSize: '24px', verticalAlign: 'middle'}}>📱</span>
                                    &nbsp;&nbsp;+420 596 425 578
                                </p>
                                <p style={{fontSize: '18px', margin: '10px 0'}}>
                                    <span style={{color: '#7CB342', fontSize: '24px', verticalAlign: 'middle'}}>✉️</span>
                                    &nbsp;&nbsp;galisinova@ecoarcz.eu
                                </p>
                                <p style={{fontSize: '18px', margin: '10px 0'}}>
                                    <span style={{color: '#7CB342', fontSize: '24px', verticalAlign: 'middle'}}>🏢</span>
                                    &nbsp;&nbsp;http://www.ecoarcz.eu/
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
